// const ENDPOINT = window.location.host.includes("localhost")
//   ? "http://localhost:4011"
//   : (window.location.host.includes("bewell2.com")) ? "https://api.bewell2.com" : "https://bewell2-dev.devlab.zone";
const ENDPOINT = "https://api.bewell2.com";
export const GQL_ENDPOINT = `${ENDPOINT}/api/graphql`;
// export const PORTAL_URL = window.location.host.includes("bewell2.com") || window.location.host.includes("webflow.io") ?
//   "https://portal.bewell2.com/patient/sign-up" :
//   "https://bewell2-portal.webflow.io/patient/sign-up";
export const PORTAL_URL = "https://portal.bewell2.com/patient/sign-up";
